import { useEffect, useState } from 'react';
import axios from 'axios';

let cache = null;
let inflight = null;
const listeners = new Set();

function notify() { for (const l of listeners) l(cache); }

export function refreshPosTypes() {
  // Coalesce concurrent calls. When a list page with N <PosBadge> rows
  // mounts, every instance's useEffect fires before the first fetch
  // resolves; without this, N parallel network requests get sent.
  if (inflight) return inflight;
  inflight = axios.get('/api/pos-types')
    .then((res) => {
      cache = res.data?.pos_types || [];
      notify();
      inflight = null;
      return cache;
    })
    .catch((err) => {
      // On failure (e.g. 403 for a salesperson), seed cache as empty
      // so further mounts don't keep retrying. PosBadge falls back to
      // grey when the type isn't in the list — the right UI for
      // "couldn't load types".
      console.warn('usePosTypes: fetch failed —', err.response?.status || err.message);
      cache = [];
      notify();
      inflight = null;
      return cache;
    });
  return inflight;
}

export default function usePosTypes() {
  const [types, setTypes] = useState(cache || []);
  useEffect(() => {
    const cb = (next) => setTypes(next || []);
    listeners.add(cb);
    if (cache === null && !inflight) refreshPosTypes();
    return () => { listeners.delete(cb); };
  }, []);
  return types;
}
